let loaderMixin = {
	data: function () {
		return {
			loader: null,
			destroying: false
		}
	},
	computed: {
		loadingProps() {
			const theme = this.$route.query.theme
			if (theme == "dark") {
				return {       
					color: "#ffffff",
					backgroundColor: "#000000",
				}
			} else {
				return undefined
			}
		}
	},
	methods: {
		toggleLoader(show) {
			if (this.destroying) {
				return
			}
			if (!this.loader && show) {
				this.loader = this.$loading.show(this.loadingProps)
			} else if (this.loader && !show) {
				this.loader.hide()
				this.loader = null
			}
		}
	},
	beforeDestroy: function () {
		this.toggleLoader(false)
		this.destroying = true
	},
}

export default loaderMixin
